import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SERVICE_DETAIL_BANNERS } from '../service-detail-banners';
import { ServiceOrbitVisualComponent } from '../shared/service-orbit-visual/service-orbit-visual.component';

@Component({
  selector: 'app-business-intelligence',
  standalone: true,
  imports: [CommonModule, RouterLink, ServiceOrbitVisualComponent],
  templateUrl: './business-intelligence.component.html',
  styleUrl: './business-intelligence.component.scss',
  host: {
    '[style.--service-banner-image]': 'serviceBannerImage',
  },
})
export class BusinessIntelligenceComponent {
  readonly serviceBannerImage = SERVICE_DETAIL_BANNERS.businessIntelligence;
}
